var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCross(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 12 12",
    style: {
      enableBackground: "new 0 0 12 12"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E4001C;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:0.5;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3263"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3262"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Glyphs_Controls_Volume_Knob",
    transform: "translate(25 414)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_373",
    className: "st0",
    cx: -19,
    cy: -408,
    r: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3261",
    transform: "translate(3.847 3.633)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1751",
    transform: "translate(24.152 413.368)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1017",
    className: "st1",
    d: "M-20-413l-4,3.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1018",
    className: "st1",
    d: "M-24-413l3.9,4"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCross);
export default __webpack_public_path__ + "static/media/icon_cross.304839e0974bdaec08088c681fa00434.svg";
export { ForwardRef as ReactComponent };